// noinspection JSUnusedGlobalSymbols

/**
 * Returns true if the specified text contains any whitespace
 * @param text String to test
 */
export function containsSpace(text: string): boolean {
    return /\s/.test(text)
}

/**
 * Returns true if the text only contains alphabet and/or numeric characters
 * @param text String to test
 */
export function isAlphaNumeric(text: string): boolean {
    return text.match(/^[a-z0-9]+$/i) !== null
}